var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuroraLogoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94.6 12",
    style: {
      enableBackground: "new 0 0 94.6 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,9.9l1.6-2.2h1.7c0.4,0,0.8,0,1.1,0c-0.1-0.1-0.4-0.5-0.5-0.7l-1.3-1.9l-3.5,4.8H21L25.9,3 c0.4-0.5,0.9-1,1.7-1c0.8,0,1.3,0.4,1.7,1l4.8,6.9H25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.7,2.1h2.7v4.4c0,2.3-1.6,3.5-4.9,3.5C35.7,10,34,8.8,34,6.5V2.1h2.7v4.4c0,1,0.3,1.3,2.7,1.3 c1.6,0,2.2-0.4,2.2-1.3V2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.3,9.9L51.9,8h-3.5v1.9h-2.7v-4h7c0.6,0,1-0.2,1-0.7c0-0.5-0.3-0.7-1-0.7h-7l1.7-2.3h4.9 c1.7,0,4.1,0.5,4.1,2.8c0,1.2-0.7,2.2-1.9,2.5c0.2,0.1,0.7,0.6,1.8,1.8l0.6,0.6H53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,10c-3.8,0-5.8-1.2-5.8-4c0-2.8,1.9-4,5.8-4s5.8,1.2,5.8,4C68.8,8.8,66.8,10,63,10z M63,4.3 c-2.3,0-3.1,0.2-3.1,1.7c0,1.5,0.8,1.7,3.1,1.7c2.3,0,3.1-0.2,3.1-1.7C66.1,4.5,65.3,4.3,63,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,9.9L76.1,8h-3.5v1.9H70v-4h7c0.6,0,1-0.2,1-0.7c0-0.5-0.3-0.7-1-0.7h-7l1.7-2.3h4.9 c1.7,0,4.1,0.5,4.1,2.8c0,1.2-0.7,2.2-1.9,2.5c0.2,0.1,0.7,0.6,1.8,1.8l0.6,0.6H77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,9.9l1.6-2.2h1.7c0.4,0,0.8,0,1.1,0c-0.1-0.1-0.4-0.5-0.5-0.7l-1.3-1.9l-3.5,4.8h-3.2L86.4,3 c0.4-0.5,0.9-1,1.7-1c0.8,0,1.3,0.4,1.7,1l4.8,6.9H85.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 18.5,
    cy: 3.8,
    rx: 0.5,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 0.5,
    cy: 4.5,
    rx: 0.5,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 3.5,
    cy: 3.8,
    rx: 0.5,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 6.5,
    cy: 3.9,
    rx: 0.5,
    ry: 3.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 9.5,
    cy: 5.9,
    rx: 0.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 12.5,
    cy: 7.4,
    rx: 0.5,
    ry: 4.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 15.5,
    cy: 6.3,
    rx: 0.5,
    ry: 4.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuroraLogoSm);
export default __webpack_public_path__ + "static/media/AURORA_LOGO_SM.20f249905adcb5b6977f82b8de4b0306.svg";
export { ForwardRef as ReactComponent };